<template>
    <v-container>
        <v-card>
            <v-card-title primary-title>
                {{ $t('statistics') }}
            </v-card-title>
        </v-card>
        <v-card class="mt-3">
            <v-card-title primary-title>
                {{ $t('incomingMinutes') }}
            </v-card-title>
            <v-card-text>
                <div v-show="selectIncomingDates">
                    <v-subheader>{{ $t('pleaseSelectDatesRange') }}</v-subheader>
                    <v-row>
                        <v-col>
                            <v-menu v-model="incomingSumFromMenu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="incomingSumFrom" :label="$t('fromDate')"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="incomingSumFrom" @input="incomingSumFromMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col>
                            <v-menu v-model="incomingSumToMenu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="incomingSumTo" :label="$t('untilDate')"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="incomingSumTo" @input="incomingSumToMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text block @click="loadIncoming">{{ $t('viewData') }}</v-btn>
                </div>
                <div v-show="incomingData">
                    <b>{{ $t('dataFrom') }} {{ incomingSumFrom }} {{ $t('until') }} {{ incomingSumTo }}.</b>
                    <br>
                    <span class="mx-auto"><b style="font-size:16px">{{ direct }}</b> - {{ $t('directMinutes') }}</span>
                    <br>
                    <span class="mx-auto"><b style="font-size:16px">{{ transferOut }}</b> -
                        {{ $t('outgoingMinutesToOtherSystems') }}</span>
                    <br>
                    <span class="mx-auto"><b style="font-size:16px">{{ transferIn }}</b> -
                        {{ $t('incomingMinutesFromOtherSystems') }}</span>
                </div>
            </v-card-text>
        </v-card>
        <v-card class="mt-3">
            <v-card-title primary-title>
                {{ $t('callsInSystemPerExt') }}
            </v-card-title>
            <v-card-text>
                <div v-show="selectExtDates">
                    <v-menu v-model="extDataMenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="extData" :label="$t('pleaseSelectMonth')" prepend-icon="mdi-calendar"
                                readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker type="month" v-model="extData" @input="extDataMenu = false">
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn v-show="selectExtDates" color="primary" text block @click="loadExtData">{{ $t('viewData') }}
                </v-btn>
                <div v-show="extShowData">
                    <b>{{ $t('dataForMonth') }} {{ extData }}.</b>
                    <br>
                    {{ $t('totalIncomingCallsCountForMonth') }}: {{ allIncomingCount }}.
                    <br>
                    <v-data-table :headers="extHeaders" :items="extItems" class="elevation-0" :items-per-page="15">
                    </v-data-table>
                </div>
            </v-card-text>
        </v-card>
        <v-card class="mt-3">
            <v-card-title primary-title>
                {{ $t('callsPerExtnetion') }}
            </v-card-title>
            <v-card-text>
                <p v-html="countExt"></p>
            </v-card-text>
        </v-card>
        <v-card class="mt-3">
            <v-card-title primary-title>
                {{ $t('summaryPointsPerUser') }}
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="pointsHeaders" :items="pointsItems" class="elevation-0" :items-per-page="15">
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        selectIncomingDates: true,
        incomingSumFromMenu: false,
        incomingSumFrom: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        incomingSumToMenu: false,
        incomingSumTo: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        incomingData: false,
        direct: 0,
        transferOut: 0,
        transferIn: 0,
        selectExtDates: true,
        extDataMenu: false,
        extShowData: false,
        extData: new Date().toISOString().substr(0, 7),
        extItems: [],
        countExt: '',
        allIncomingCount: 0,
        pointsItems: [],
    }),
    computed: {
        extHeaders() {
            return [
                {
                    text: 'שלוחה',
                    align: 'start',
                    value: 'Folder'
                },
                { text: this.$t('phone'), value: 'Phone' },
                { text: this.$t('incomingDid'), value: 'IncomingDID' },
                { text: this.$t('hebrewDate'), value: 'EnterHebrewDate' },
                { text: this.$t('date'), value: 'EnterDate' },
                { text: this.$t('loginTime'), value: 'EnterTime' },
                { text: this.$t('exitTime'), value: 'ExitTime' },
                { text: this.$t('totalTimeS'), value: 'TimeTotal' },
            ]
        },
        pointsHeaders() {
            return [
                {
                    text: this.$t('userEnterId'),
                    align: 'start',
                    value: 'id'
                },
                { text: this.$t('userType'), value: 'Type' },
                { text: this.$t('totalPoints'), value: 'PointsTotal' },
            ]
        }
    },
    methods: {
        loadIncoming() {
            (async () => {
                const body = { token: sessionStorage.token, from: this.incomingSumFrom, to: this.incomingSumTo };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetIncomingSum`, body);
                this.selectIncomingDates = false;
                this.incomingData = true;
                this.direct = response.data.direct;
                this.transferIn = response.data.transferIn;
                this.transferOut = response.data.transferOut;
            })();
        },
        loadExtData() {
            (async () => {
                const body = { token: sessionStorage.token, wath: `ivr2:Log/LogFolderEnterExit-${this.extData}.ymgr`, convertType: 'json', notLoadLang: 1 };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/RenderYMGRFile`, body);
                if (response.data.responseStatus === "OK") {
                    this.selectExtDates = false;
                    this.extShowData = true;
                    this.extItems = response.data.data.reverse();
                    for (let item of this.extItems) {
                        if (item.Folder === "main") {
                            item.Folder = this.$t('main');
                        }
                    }
                }
                else {
                    alert(this.$t('notFoundDataForThisMonth'))
                }
            })();
            (async () => {
                const body = { token: sessionStorage.token, what: `ivr2:Log/IncomingCount_${this.extData}.ini` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                this.allIncomingCount = response.data.contents.replace(/AllIncoming=/g, '');
            })();
        },
        loadCountExt() {
            (async () => {
                const body = { token: sessionStorage.token, what: `ivr2:Log/LogCounters.ini` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                this.countExt = response.data.contents.replace(/Foldar-/g, `${this.$t('extnetion')} `).replace(/=/g, ": ").replace(" ", ` ${this.$t('main1')}`).replace(/\n/g, "<br>").replace(/Star/g, "*");
            })();
        },
        loadPointsData() {
            (async () => {
                const body = { token: sessionStorage.token, wath: `ivr2:Points/points_total.ymgr`, convertType: 'json', notLoadLang: 1 };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/RenderYMGRFile`, body);
                this.pointsItems = response.data.data;
                const userTypes = {
                    phone: this.$t('phone'),
                    teudat_zehut: this.$t('teudatZehut'),
                    list: this.$t('list'),
                    enter_phone_list: this.$t('phoneList'),
                    digits: this.$t('personalPin'),
                    phone_or_enter_phone: this.$t('phoneOrEnterPhone'),
                }
                if (this.pointsItems) {
                    for (let item of this.pointsItems) {
                        item.Type = userTypes[item.Type] || item.Type;
                    }
                }
            })();
        },
    },
    beforeMount() {
        this.loadCountExt();
        this.loadPointsData();
    }
}
</script>